import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import type { ShokurekishoImageItem } from '@/composables/format-edit/useShokurekishoFormatData'

type FeatureHooks = {
  onSuccess: () => void
  onCancel: () => void
  onError?: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoImageUploadFields',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: ShokurekishoImageItem
};



const { vm, globalVar, yagiprimePaymentService, message } = useHostServices()
const isYagiPrime = computed(() => !!globalVar.isYagiPrime)
const editableItem = computed(() => props.item)

const mainImageInput = ref<HTMLInputElement | null>(null)
const subImageInputs: Record<number, HTMLInputElement | null> = {}

function subImageAt(n: number): string | null {
  const key = `subImage${n}` as keyof ShokurekishoImageItem
  const value = editableItem.value[key]
  return typeof value === 'string' ? value : value || null
}

function setSubImageInput(n: number, el: unknown) {
  const node = Array.isArray(el) ? el[0] : el
  subImageInputs[n] = (node as HTMLInputElement) || null
}

function handleImageUpload(type: string) {
  if (type === 'main') {
    mainImageInput.value?.click()
    return
  }
  const n = Number(type.replace('sub', ''))
  subImageInputs[n]?.click()
}

function onSubSlotClick(n: number) {
  if (isYagiPrime.value) {
    handleImageUpload(`sub${n}`)
    return
  }
  yagiprimePaymentService.useFeature(
    vm,
    'shokurekisho-with-image-add-sub-image',
    {
      onSuccess: () => {
        message({
          message: '成功しました',
          type: 'success'
        })
      },
      onCancel: () => {},
      onError: () => {
        message({
          message: '失敗しました',
          type: 'error'
        })
      }
    } as FeatureHooks
  )
}

function setImageField(type: string, value: string | null) {
  if (type === 'main') {
    editableItem.value.mainImage = value
    return
  }
  const n = type.replace('sub', '')
  const key = `subImage${n}` as keyof ShokurekishoImageItem
  ;(editableItem.value as Record<string, string | null>)[key] = value
}

function onImageSelected(event: Event, type: string) {
  const input = event.target as HTMLInputElement
  const file = input.files && input.files[0]
  if (!file) return
  setImageField(type, null)
  const reader = new FileReader()
  reader.onload = (e) => {
    const result = e.target && e.target.result
    setImageField(type, typeof result === 'string' ? result : null)
  }
  reader.readAsDataURL(file)
}

function deleteImage(type: string) {
  setImageField(type, null)
}

return { __sfc: true,props, vm, globalVar, yagiprimePaymentService, message, isYagiPrime, editableItem, mainImageInput, subImageInputs, subImageAt, setSubImageInput, handleImageUpload, onSubSlotClick, setImageField, onImageSelected, deleteImage }
}

})